/**
 * Mutation `isPending` flips a render too late to stop a double-click, so gate
 * every launch on this. Module-level so two surfaces offering the same routine
 * serialise against each other.
 */
const holders = new Map<string, Set<string>>();

export interface RoutineLaunchLock {
  tryBegin: (workflowId: string) => boolean;
  end: (workflowId: string) => void;
  has: (workflowId: string) => boolean;
  releaseAll: () => void;
}

export const createRoutineLaunchLock = (): RoutineLaunchLock => {
  const owned = new Set<string>();
  return {
    tryBegin: (workflowId) => {
      if (holders.has(workflowId)) return false;
      holders.set(workflowId, owned);
      owned.add(workflowId);
      return true;
    },
    end: (workflowId) => {
      if (holders.get(workflowId) !== owned) return;
      holders.delete(workflowId);
      owned.delete(workflowId);
    },
    has: (workflowId) => holders.has(workflowId),
    releaseAll: () => {
      owned.forEach((workflowId) => {
        if (holders.get(workflowId) === owned) holders.delete(workflowId);
      });
      owned.clear();
    },
  };
};

export const __resetRoutineLaunchLocksForTests = (): void => {
  holders.clear();
};
